<button (click)="actionButtton()" [id]="id" [ngStyle]="{'width':width}" [ngClass]="classButton + ' ' + gtm" mat-raised-button [color]="color" [(disabled)]="disabled" class="btn">
    <span class="btn-content" [ngClass]="gtm" [fxLayout]="direction" [fxLayoutAlign]="align" fxLayoutGap="{'10px': haveIcon}">
        <span [ngClass]="{'mr-2': haveIcon } + ' ' + gtm" *ngIf="haveTitle">
            {{ title }}
        </span>
        <i *ngIf="haveIcon" [ngClass]="classIcon" [ngClass]="gtm"></i>
    </span>
</button>
